import type { CSSProperties } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './switch.module.scss';

const styles = pickCss(css, css.root);

type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
};

/** Binary toggle. Mirrors the legacy task form's "Use custom date" switch. */
export const Switch = ({
  checked,
  onCheckedChange,
  disabled,
  id,
  className,
  style,
  'aria-label': ariaLabel,
}: SwitchProps) => (
  <button
    aria-checked={checked}
    aria-label={ariaLabel}
    className={styles(
      { isChecked: checked, isDisabled: !!disabled },
      className
    )}
    disabled={disabled}
    id={id}
    onClick={() => onCheckedChange(!checked)}
    role="switch"
    style={style}
    type="button"
  >
    <span className={css.thumb} />
  </button>
);
